import { useNavigate } from "react-router-dom";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center h-screen text-center">
            
            <img  className='w-1/12' src={require('../images/fishcord-logo-nbg.png')} alt="Fishcord logo" />
            <h1 className="text-4xl font-bold">404</h1>
            <p className="text-lg mt-2">Oops! You're lost.</p>
            <button 
                onClick={() => navigate("/")} 
                className="mt-4 p-3 text-xl rounded-lg border border-black bg-black text-primaryColor hover:bg-secondaryColor hover:text-black hover:rounded-none duration-300"
            >
                Go Home
            </button>
        </div>
    );
};

export default NotFound;
